import { useEffect, useState } from "react";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import AssistantPanel from "./AssistantPanel";

/**
 * Floating button that opens the assistant; Ctrl/⌘+J toggles it from anywhere. `className`
 * positions it, so the partner portal can lift it above its mobile tab bar.
 */
const AssistantLauncher = ({ surface = "admin", className = "bottom-6 right-6" }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "j") {
        event.preventDefault();
        setOpen((current) => !current);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <>
      {open ? null : (
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label="Open the assistant"
          title="Ask the assistant (Ctrl/⌘ + J)"
          className={`group fixed z-40 inline-flex items-center gap-2 rounded-full border-0 bg-gradient-to-br from-teal-600 to-emerald-600 py-3 pl-3 pr-3 text-white shadow-lg shadow-teal-900/20 cursor-pointer transition-all hover:pr-4 hover:shadow-xl ${className}`}
        >
          <AutoAwesomeOutlinedIcon sx={{ fontSize: 22 }} />
          <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-all duration-200 group-hover:max-w-[8rem]">
            Ask Kothar
          </span>
        </button>
      )}
      <AssistantPanel open={open} onClose={() => setOpen(false)} surface={surface} />
    </>
  );
};

export default AssistantLauncher;
